import queryString from 'query-string';
import ICampaignID from '../../types/ICampaignID';
import ICampaignInfoContainer from "../../types/ICampaignInfoContainer";

// Class to work with query string as a campaing UUID container
export default class CampaignInfoParamContainer implements ICampaignInfoContainer {
  readonly containerName = 'param';
  readonly parameterName = 'campaign';

  load() {
    const paramValue= queryString.parse(location.search)[this.parameterName];
    const result: ICampaignID = {
      UUID: paramValue ? paramValue.toString() : null,
      container: this.containerName
    };
    return result.UUID ? result : null;
  }

  store (campaignId: ICampaignID) {
    return !!campaignId;
  }
}